import { ClippingBoxViewControls } from "@/components/ui/clipping-box-view-controls";

import { setIpxClippingBoxEnabled } from "@/store/modes/ipx-order-mode-slice";
import { useAppDispatch, useAppSelector } from "@/store/store-hooks";
import { selectActiveWizardStepKey } from "@/store/wizard/wizard-selectors";
import { useBoxControlsContext } from "@/utils/box-controls-context";
import { useBreakpointMdUp } from "@faro-lotv/flat-ui";
import type { JSX } from "react";
import { IpxCheckoutDialog } from "./ipx-checkout-dialog";
import { IpxOrderStepKey } from "./ipx-order-steps";
import { recenterIpxViewEvent } from "./ipx-view-events";

/** @returns the in-scene tools of the active step, and the IPX checkout once the user continues to it */
export function IpxOrderModeOverlay(): JSX.Element {
  return (
    <>
      <AreaTools />
      <IpxCheckoutDialog />
    </>
  );
}

/** @returns the in-scene tools of the volume step: the clipping box toggle, the box and the camera tools */
function AreaTools(): JSX.Element | null {
  const dispatch = useAppDispatch();
  const stepKey = useAppSelector(selectActiveWizardStepKey);
  const isClippingBoxEnabled = useAppSelector(
    (state) => state.ipxOrderMode.isClippingBoxEnabled,
  );
  const isMdUp = useBreakpointMdUp();
  const { autoBoxEvent, resetBoxEvent } = useBoxControlsContext();

  if (stepKey !== IpxOrderStepKey.defineArea) return null;

  return (
    <ClippingBoxViewControls
      isBoxEnabled={isClippingBoxEnabled}
      onBoxEnabledChange={(isEnabled) =>
        dispatch(setIpxClippingBoxEnabled(isEnabled))
      }
      // Small screens keep only the essential tools, to fit above the step sheet
      onResetBox={() => resetBoxEvent.emit()}
      // The box handles can't be dragged on touch screens, there the box is fitted to the view instead
      onFitBoxToView={() => autoBoxEvent.emit()}
      onRecenterView={isMdUp ? () => recenterIpxViewEvent.emit() : undefined}
      showCameraSwitch={isMdUp}
    />
  );
}
